import { constants } from '..';

const INITIAL_STATE = {
  loading: false,
  groups: [],
  total: 0,
  header: {},
  selectedGroup: {},
};

export const clientGroupsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.clientGroups.SET_CLIENT_GROUPS_LOADING:
      return {
        ...state,
        loading: action.flag,
      };
    case constants.clientGroups.SET_CLIENT_GROUPS:
      return {
        ...state,
        groups: action.groups,
        total: action.total,
        header: action.header || {},
      };
    case constants.clientGroups.SET_CLIENT_GROUP:
      return {
        ...state,
        selectedGroup: action.group,
      };
    case constants.clientGroups.CLEAR_CLIENT_GROUPS:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
